module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.compIsVisible) ? _c('div', {
    staticClass: "edit_objects_menu bg-lgrey"
  }, [_c('div', {
    staticClass: "edit_objects_menu_head"
  }, [_c('span', {
    staticClass: "h6 medium"
  }, [_vm._v(_vm._s(_vm.compElement.name))]), _vm._v(" "), (_vm.compElement.wood) ? _c('span', {
    staticClass: "h7 c-dark upcase"
  }, [_vm._v(" " + _vm._s(_vm.compElement.wood))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "edit_objects_menu_content"
  }, [_c('div', {
    staticClass: "menu_obj_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.compElement.side_active_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "edit_object_depth"
  }, [_c('span', {
    staticClass: "medium h7 upcase"
  }, [_vm._v(_vm._s(_vm.$t("depth")))]), _vm._v(" "), _vm._l((_vm.compDepths), function(depth) {
    return _c('button', {
      staticClass: "c-dgrey regular h6",
      class: {
        selected: _vm.compElement.depth === depth
      },
      on: {
        "click": function($event) {
          _vm.emitSelectDepth(depth, _vm.compElement)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(depth) + "\t\n\t\t\t")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "edit_object_position"
  }, [_c('div', {
    staticClass: "edit_object_position_box"
  }, [_c('div', {
    staticClass: "edit_object_position_text"
  }, [_c('span', {
    staticClass: "medium h7 upcase"
  }, [_vm._v(_vm._s(_vm.$t("sposta")))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "regular h8"
  }, [_vm._v(_vm._s(_vm.$t("ripiano")))])]), _vm._v(" "), _c('step-btn', {
    attrs: {
      "hidelabel": true,
      "isarrow": true,
      "steps": _vm.compPositions,
      "current": _vm.compCurrentPosition
    },
    on: {
      "change": _vm.emitOnPositionChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "edit_object_position_box"
  }, [_c('div', {
    staticClass: "edit_object_position_text"
  }, [_c('span', {
    staticClass: "medium h7 upcase"
  }, [_vm._v(_vm._s(_vm.$t("distanza")))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "regular h8"
  }, [_vm._v(_vm._s(_vm.$t("dal_ripiano")))])]), _vm._v(" "), _c('div', {
    staticClass: "regular h6 edit_object_position_distance"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.compTopDistance) + "\n\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "edit_objects_menu_controls bg-lgrey"
  }, [_c('button', {
    staticClass: "h7",
    on: {
      "click": _vm.emitDelete
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("delete")) + "\n\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "h7 bg-accent c-light",
    on: {
      "click": _vm.emitConfirm
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("confirm")) + "\n\t\t")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15da82a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/EditElementMenu.vue
// module id = 623
// module chunks = 0